function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.34 5.999H5.997v2.857a1 1 0 01-2 0V5.999H.653a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3.344V1.142a1 1 0 012 0v2.857H9.34c.277 0 .502.224.502.5v1c0 .276-.225.5-.502.5z"
});

var SvgCreate = function SvgCreate(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOS4zNCA1Ljk5OUg1Ljk5N3YyLjg1N2ExIDEgMCAwIDEtMiAwVjUuOTk5SC42NTNhLjUuNSAwIDAgMS0uNS0uNXYtMWEuNS41IDAgMCAxIC41LS41aDMuMzQ0VjEuMTQyYTEgMSAwIDAgMSAyIDB2Mi44NTdIOS4zNGMuMjc3IDAgLjUwMi4yMjQuNTAyLjV2MWMwIC4yNzYtLjIyNS41LS41MDIuNXoiLz4KPC9zdmc+Cg==";
export { SvgCreate as ReactComponent };